import { For, Show, type VoidProps } from "solid-js";
import { useApi, useInvites, useUsers } from "@/api";
import { Time } from "@/atoms/Time.tsx";
import { Avatar } from "@/components/shared/User";
import type { RoomT } from "@/types";
import { Copyable, getDate } from "@/utils/general";

export function Invites(_props: VoidProps<{ room: RoomT }>) {
	const api2 = useApi();
	const invites2 = useInvites();
	const users2 = useUsers();

	const invites = invites2.useServerList();

	const createInvite = () => {
		api2.client.http.POST("/api/v1/server/invite", {
			body: {},
		});
	};

	const deleteInvite = (code: string) => {
		api2.client.http.DELETE("/api/v1/invite/{invite_code}", {
			params: {
				path: { invite_code: code },
			},
		});
	};

	return (
		<>
			<h2>invites</h2>
			<button type="button" class="button big primary" onClick={createInvite}>
				create invite
			</button>
			<br />
			<div class="invites">
				<Show when={!invites.loading} fallback="loading...">
					<header>
						<div class="code">code</div>
						<div class="creator">creator</div>
						<div class="uses">uses</div>
						<div class="expires">expires</div>
					</header>
					<ul>
						<For each={invites()?.state.ids}>
							{(code) => {
								const i = invites2.cache.get(code);
								if (!i) return null;
								const user = users2.use(() => i.creator_id);
								const creatorName = () => user()?.name || "unknown";
								return (
									<li class="invites-invite">
										<div class="code">
											<Copyable>{i.code}</Copyable>
										</div>
										<div class="creator">
											<Avatar user={i.creator} pad={0} />
											<div class="info">
												<div class="name">{creatorName()}</div>
												<Time date={getDate(i.created_at)} />
											</div>
										</div>
										<div class="uses">
											<span class="mono">{(i as any).uses ?? 0}</span>
											<span class="dim">/</span>
											<span class="mono">
												{(i as any).max_uses ?? "\u221e"}
											</span>
										</div>
										<div class="expires">
											<Show
												when={i.expires_at}
												fallback={<span class="dim">never</span>}
											>
												<Time date={getDate(i.expires_at!)} />
											</Show>
										</div>
										<div>
											<button
												type="button"
												class="button"
												onClick={() => deleteInvite(i.code)}
											>
												delete
											</button>
										</div>
									</li>
								);
							}}
						</For>
					</ul>
				</Show>
			</div>
		</>
	);
}
